import React, { useEffect, useState } from 'react';
import api from '../api';
import Avatar from '../components/Avatar';
import useCoachAvatars from '../hooks/useCoachAvatars';

const TABS = ['submitted', 'approved', 'billed', 'paid'];

const Submissions = () => {
  const [tab, setTab] = useState('submitted');
  const [items, setItems] = useState([]);
  const [selected, setSelected] = useState([]);
  const [success, setSuccess] = useState('');
  // Fetched once for the page, not once per row. The same coaches repeat
  // across hundreds of rows and that only grows.
  const avatars = useCoachAvatars();

  const load = (status) => api.get(`/api/submissions?status=${status}`).then(res => { setItems(res.data); setSelected([]); });
  useEffect(() => { load(tab); }, [tab]);

  const toggle = (id) => setSelected(sel => sel.includes(id) ? sel.filter(x => x !== id) : [...sel, id]);
  const toggleAll = () => setSelected(sel => sel.length === items.length ? [] : items.map(i => i.id));

  const approve = async () => {
    if (!selected.length) return;
    const res = await api.post('/api/submissions/approve', { ids: selected });
    setSuccess(`${res.data.approved} submission(s) approved.`);
    load(tab);
  };

  // A DATE column arrives as 'YYYY-MM-DD'. Build it from its parts so the
  // browser's timezone cannot shift it onto the day before.
  const fmtDate = (d) => {
    if (!d) return '—';
    const [y, m, day] = String(d).slice(0, 10).split('-').map(Number);
    if (!y || !m || !day) return String(d);
    return new Date(y, m - 1, day).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
  };

  // created_at is a real timestamp, so the browser can parse it directly.
  const fmtLogged = (t) => (t ? new Date(t).toLocaleString('en-GB', {
    day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit'
  }) : '—');

  const describe = (s) =>
    s.session_type === 'away_game'
      ? `Away @ ${s.venue_name || 'venue not set'}`
      : (s.session_label || 'Session');

  return (
    <>
      <h1>Coach submissions</h1>
      {success && <div className="success-msg">{success}</div>}
      <div className="tabs">
        {TABS.map(t => (
          <button key={t} className={tab === t ? 'active' : ''} onClick={() => setTab(t)}>
            {t.charAt(0).toUpperCase() + t.slice(1)}
          </button>
        ))}
      </div>

      <div className="card">
        {tab === 'submitted' && items.length > 0 && (
          <div style={{ marginBottom: '0.75rem' }}>
            <button className="btn orange" disabled={!selected.length} onClick={approve}>
              Approve selected ({selected.length})
            </button>
          </div>
        )}
        {items.length === 0 ? <p className="muted">Nothing here.</p> : (
          <table>
            <thead>
              <tr>
                {tab === 'submitted' && <th><input type="checkbox" checked={selected.length === items.length} onChange={toggleAll} /></th>}
                <th>Coach</th><th>Session date</th><th>Logged on</th><th>Session</th><th>Hours</th><th>Mileage</th><th>Total</th>
              </tr>
            </thead>
            <tbody>
              {items.map(s => (
                <tr key={s.id}>
                  {tab === 'submitted' && <td><input type="checkbox" checked={selected.includes(s.id)} onChange={() => toggle(s.id)} /></td>}
                  <td>
                    <span className="cell-with-avatar">
                      <Avatar name={s.coach_name} src={avatars[s.coach_id]} size="sm" />
                      {s.coach_name}
                    </span>
                  </td>
                  <td>{fmtDate(s.session_date)}</td>
                  <td className="muted">{fmtLogged(s.created_at)}</td>
                  <td>{describe(s)}</td>
                  <td>{s.hours}</td>
                  <td>{s.miles > 0 ? `${s.miles} mi / £${Number(s.mileage_amount).toFixed(2)}` : '—'}</td>
                  <td>£{Number(s.line_total).toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </>
  );
};

export default Submissions;
